import Action from "../Action";
export default class Macro extends Action {
    constructor(...subactions) {
        super();
        this._name = "Macro";
        this.subactions = [...subactions];
    }
    toString() {
        return `${super.toString()} [${this.subactions.length}]`;
    }
}
